let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9jcb2")).then(() => parcelRequire('4iDjt'));